var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileParticulier(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 31.4256 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1525",
    d: "M15.7142 0C10.9973 0 7.14002 3.84634 7.14002 8.56326C7.14002 13.2802 10.9973 17.1344 15.7142 17.1344C20.4311 17.1344 24.2883 13.2802 24.2883 8.56326C24.2883 3.84634 20.4311 0 15.7142 0ZM15.7142 2.85717C18.887 2.85717 21.4284 5.39048 21.4284 8.56326C21.4284 11.736 18.887 14.2773 15.7142 14.2773C12.5414 14.2773 9.99714 11.736 9.99714 8.56326C9.99714 5.39048 12.5414 2.85717 15.7142 2.85717ZM12.8571 19.9946C5.75896 19.9946 0 25.7507 0 32.8488V40H2.85992V32.8488C2.85992 27.2841 7.29238 22.8514 12.8571 22.8514H18.5713C24.136 22.8514 28.5684 27.2841 28.5684 32.8488V40H31.4256V32.8488C31.4256 25.7507 25.6694 19.9946 18.5713 19.9946H12.8571Z",
    fill: "url(#paint0_linear_0_81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1525_2",
    d: "M15.7142 0C10.9973 0 7.14002 3.84634 7.14002 8.56326C7.14002 13.2802 10.9973 17.1344 15.7142 17.1344C20.4311 17.1344 24.2883 13.2802 24.2883 8.56326C24.2883 3.84634 20.4311 0 15.7142 0ZM15.7142 2.85717C18.887 2.85717 21.4284 5.39048 21.4284 8.56326C21.4284 11.736 18.887 14.2773 15.7142 14.2773C12.5414 14.2773 9.99714 11.736 9.99714 8.56326C9.99714 5.39048 12.5414 2.85717 15.7142 2.85717Z",
    fill: "var(--fill-0, #119ED9)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_81",
    x1: -0.190931,
    y1: 1.74217,
    x2: 38.3755,
    y2: 11.9939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileParticulier);
export default __webpack_public_path__ + "static/media/profile-particulier.3f7dfb82feffd01f07773efe9ff6dab1.svg";
export { ForwardRef as ReactComponent };